import React, { useEffect, useState } from "react";

import { useParams } from "react-router";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Button,
  SimpleGrid,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@chakra-ui/react";

import CustomSelect from "../../../../components/CustomSelect";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";

import FamiliaAcolhedoraSAService from "../../../../../main/services/FamiliaAcolhedoraSAService";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import DadosGeograficosService from "../../../../../main/services/DadosGeograficosService";

const CadastrarFamiliaAcolhedoraModal = ({ isOpen, onOpen, onClose }) => {
  const { id } = useParams();

  const [bairros, setBairros] = useState({ options: [], isLoading: false });

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);

    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setBairros({ ...bairros, isLoading: true });
        DadosGeograficosService.pesquisarBairros(res.data.endereco.municipio.id)
          .then((resp) => {
            setBairros({ options: resp.data, isLoading: false });
          })
          .catch((error) => {
            console.log("Erro ao pesquisar o bairro", error);
          });
      })
      .catch((error) => {
        console.log("Erro ao acessar o Servico de Acolhimento", error);
      });
  }, [bairros, id]);

  const backAlert = () => {
    Swal.fire({
      title: "Tem certeza que deseja cancelar?",
      text: "As informações serão perdidas.",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        onClose();
      }
    });
  };

  const schema = Yup.object().shape({
    numeroProntuario: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    genero: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    outros: Yup.string().when("genero", {
      is: (genero) => (genero ? genero.value === "Outros" : false),
      then: Yup.string()
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!"),
    }),
    dataNascimento: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test(
        "dataNascimentoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (value === null) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }
      )
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    idBairro: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { genero, outros, dataNascimento, idBairro, ...resto } = values;

      const valuesToSend = {
        genero: genero.value !== "Outros" ? genero.value : outros,
        idBairro: idBairro ? idBairro.id : "",
        outros: genero.value === "Outros" ? outros : "",
        dataNascimento: dataNascimento
          ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        ...resto,
      };

      FamiliaAcolhedoraSAService.novaFamiliaAcolhedoraSA(id, valuesToSend)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro cadastrado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            onClose();
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "familia") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message
                      ? JSON.parse(error.response.data.message).familia
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {});
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={backAlert} size="6xl">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#95BCBF"
        >
          CADASTRAR ACOLHEDOR (A)
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          <Formik
            validationSchema={schema}
            initialValues={{
              numeroProntuario: "",
              genero: "",
              outros: "",
              dataNascimento: "",
              idBairro: "",
            }}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {(props) => (
              <Form>
                <Flex flexDir="column">
                  <Grid
                    mt="20px"
                    templateColumns={{
                      base: "repeat(1, 1fr)",
                      lg: "repeat(2, 1fr)",
                    }}
                    gap="20px"
                    rowGap="15px"
                  >
                    <GridItem colSpan={1}>
                      <Field name="numeroProntuario">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={
                              form.errors.numeroProntuario &&
                              form.touched.numeroProntuario
                            }
                            id="numeroProntuario"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor="numeroProntuario"
                            >
                              Número do Prontuário*
                            </FormLabel>
                            <Input
                              {...field}
                              h="42px"
                              name="numeroProntuario"
                              id="numeroProntuario"
                              backgroundColor="#fff"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe o Prontuário"
                            />
                            <FormErrorMessage>
                              {form.errors.numeroProntuario}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </GridItem>
                    <GridItem colSpan={1}>
                      <Field name="genero">
                        {({ field, form }) => (
                          <FormControl
                            name="genero"
                            isInvalid={
                              form.errors.genero && form.touched.genero
                            }
                            id="genero"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor="genero"
                            >
                              Gênero*
                            </FormLabel>
                            <CustomSelect
                              isInvalid={
                                form.errors.genero && form.touched.genero
                              }
                              value={props.values.genero || ""}
                              searchable={true}
                              options={[
                                { label: "Masculino", value: "Masculino" },
                                { label: "Feminino", value: "Feminino" },
                                { label: "Homem Trans", value: "Homem Trans" },
                                {
                                  label: "Mulher Trans",
                                  value: "Mulher Trans",
                                },
                                { label: "Não-binário", value: "Não-binário" },
                                { label: "Travesti", value: "Travesti" },
                                { label: "Intersexo", value: "Intersexo" },
                                { label: "Outros", value: "Outros" },
                              ]}
                              placeholder="Selecione o Gênero"
                              onChange={(value) => {
                                props.setFieldValue("genero", value);
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.genero}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </GridItem>
                    {(props.values.genero
                      ? props.values.genero.value === "Outros"
                      : false) && (
                      <GridItem colSpan={1}>
                        <Field name="outros">
                          {({ field, form }) => (
                            <FormControl
                              isInvalid={
                                form.errors.outros && form.touched.outros
                              }
                              id="outros"
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="outros"
                              >
                                Outros*
                              </FormLabel>
                              <Input
                                {...field}
                                h="42px"
                                name="outros"
                                id="outros"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                placeholder="Informe Outros"
                              />
                              <FormErrorMessage>
                                {form.errors.outros}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </GridItem>
                    )}
                    <GridItem colSpan={1}>
                      <CustomDatepickerWField
                        fieldName="dataNascimento"
                        label="Data de Nascimento*"
                        placeholder="DD/MM/AAAA"
                      />
                    </GridItem>
                    <GridItem colSpan={1}>
                      <Field name="idBairro">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={
                              form.errors.idBairro && form.touched.idBairro
                            }
                            id="idBairro"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor="idBairro"
                            >
                              Bairro*
                            </FormLabel>
                            <CustomSelect
                              isInvalid={
                                form.errors.idBairro && form.touched.idBairro
                              }
                              searchable={true}
                              value={form.values.idBairro || ""}
                              isClearable={true}
                              getOptionLabel={(option) => option.nome}
                              getOptionValue={(option) => option.id}
                              autoload={false}
                              isLoading={bairros.isLoading}
                              options={bairros.options}
                              placeholder="Selecione o Bairro"
                              onChange={(value) => {
                                form.setFieldValue(
                                  "idBairro",
                                  value ? value : ""
                                );
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.idBairro}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </GridItem>
                  </Grid>

                  <SimpleGrid
                    alignSelf="center"
                    mt="20px"
                    columns={2}
                    spacing="15px"
                    w={{ base: "100%", lg: "40%" }}
                  >
                    <Button
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      onClick={backAlert}
                    >
                      Voltar
                    </Button>
                    <Button
                      type="submit"
                      translate="no"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      isLoading={props.isSubmitting}
                    >
                      Salvar
                    </Button>
                  </SimpleGrid>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CadastrarFamiliaAcolhedoraModal;
